import { useEffect, useMemo, useState } from "react";
import { Form, FormControl, FormSelect } from "react-bootstrap";
import { useFormikContext } from "formik";

import { AddFareZone } from "../../types/AddFareZone";
import { EditFareZone } from "../../types/EditFareZone";
import { FareZone } from "../../types/FareZone";
import { User } from "../../types/User";

import UserService from "../../services/UserService";

import { ErrorMessage } from "../../@ui/ErrorMessage";
import { useAlertContext } from "../alert/AlertContext";

export interface FareZoneFormDetailsTabProps {
  currentFareZone: FareZone | undefined;
  reviewMode: boolean;
}

const FareZoneFormDetailsTab = ({
  currentFareZone,
  reviewMode,
}: FareZoneFormDetailsTabProps) => {
  const { values, errors, touched, handleBlur, handleChange } =
    useFormikContext<AddFareZone | EditFareZone>();

  const [userList, setUserList] = useState<User[] | undefined>();

  const alertContext = useAlertContext();
  const userService = useMemo(
    () => new UserService(alertContext.showAlert),
    [alertContext],
  );

  useEffect(() => {
    userService.getAll().then((users) => {
      setUserList(users);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <Form.Group>
        <Form.Label htmlFor="name">Name</Form.Label>
        {errors.name && touched.name && (
          <ErrorMessage>{errors.name}</ErrorMessage>
        )}
        <FormControl
          type="text"
          name="name"
          id="name"
          value={values.name}
          onChange={handleChange}
          onBlur={handleBlur}
          disabled={reviewMode}
          readOnly={reviewMode}
        />
      </Form.Group>

      <Form.Group>
        <Form.Label htmlFor="schemeCoordinator">Scheme Coordinator</Form.Label>
        {errors.schemeCoordinatorId && touched.schemeCoordinatorId && (
          <ErrorMessage>{errors.schemeCoordinatorId?.toString()}</ErrorMessage>
        )}
        <FormSelect
          id="schemeCoordinatorId"
          name="schemeCoordinatorId"
          value={values.schemeCoordinatorId}
          onChange={handleChange}
          onBlur={handleBlur}
          placeholder="Select a user"
          disabled={reviewMode}>
          <option value="" disabled>
            Select a user
          </option>
          {userList?.map((user) => (
            <option key={user.id} value={user.id}>
              {user.firstName} {user.lastName}
            </option>
          ))}
        </FormSelect>
      </Form.Group>
      <Form.Group>
        {currentFareZone !== undefined && (
          <>
            <FormControl
              type="text"
              id="lastModifiedDate"
              plaintext
              readOnly
              value={`Last Modified:  ${new Date(
                Date.parse(currentFareZone.lastModifiedDate),
              ).toLocaleString("en-GB", {
                dateStyle: "short",
                timeStyle: "short",
              })}`}
            />

            <FormControl
              type="text"
              id="LastModifiedBy"
              plaintext
              readOnly
              value={`Last Modified By: ${currentFareZone.lastModifiedBy.firstName} ${currentFareZone.lastModifiedBy.lastName}`}
            />
          </>
        )}
      </Form.Group>
    </>
  );
};

export default FareZoneFormDetailsTab;
